import React, { useState, useEffect } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";

import {
  setWordsMain,
  setWordInAnswer,
  setLanguageType,
  setNewArrayFooterUi,

} from "../../../redux/action/user";
import {
  setEditLanguage,
  setEditWord, setEditWords
} from "../../../redux/action/Edit";
import { CropPortraitTwoTone } from "@material-ui/icons";
import { VALUE_STATE } from "../../../redux/action/types";

export default function AutocompleteWordbank(props) {
  const user = useSelector((state) => state.user);
  const EditState = useSelector((state) => state.Edit);

  const dispatch = useDispatch();
  const [filterWord, setFilterWord] = useState([]);
  const [chosenWord, setChosenWord] = useState([]);
  const [question, setQuestions] = useState([])
  const [emptyArr, setEmptyArr] = useState(false)


  const [lang, setLang] = useState("fa");
  var wordTextArray = [];
  var newArrayFooter = [];
  var newArrayFooterUi = [];
  // functions

  const onChangeHandler = (e, value, o, d) => {

    if (o === "select-option") {
      question.push(
        {
          word_id: value[value.length - 1]._id,
          word: value[value.length - 1].word,
        }
      )
    }
    else if (o === "clear") {
      // if(EditState.edit && (EditState.type === "L" || EditState.type === "T") ){
      //   dispatch(setEditWord([]))
      // }
      setQuestions([])
    }


    value.forEach((item) => {
      newArrayFooter.push(item.word);
    });
    user.conditionalType !== "T" &&
      value.forEach((item) => {
        newArrayFooterUi.push({ word: item.word });
        let filter = newArrayFooterUi.filter((ele, ind) => ind === newArrayFooterUi.findIndex(elem => elem.word === ele.word))
        dispatch(setNewArrayFooterUi(filter));
      });

    let FilternewArrayFooterUi = []
    newArrayFooterUi.forEach((el, index) => {
      return FilternewArrayFooterUi.map(word => word.word !== el.word && FilternewArrayFooterUi.push(el))
    })

    if (props.type === "blank-type") {
      dispatch(setWordsMain(wordTextArray));
    }

    if (props.type === "word-bank") {
      dispatch(setWordsMain(question));
      dispatch(setEditWords(question))
    }

    if (props.type === "listening") {
      dispatch(setWordInAnswer(question));
      dispatch(setEditWord(question));
    }
    setChosenWord(value);
    props.setQuestionWord(value);



  };



  var allanswerFromApi;
  if (EditState.type === "L" || EditState.type === "T") {
    allanswerFromApi = EditState.edit && EditState.word ? EditState.word.map((item) => item) : undefined;
  } else {
    allanswerFromApi = EditState.edit && EditState.words ? EditState.words.map((item) => item) : undefined;

  }



  const FuncClearAllAnswer = document.querySelector(".MuiAutocomplete-clearIndicator");
  FuncClearAllAnswer && FuncClearAllAnswer.addEventListener("click", function () {
    setQuestions([])
    
  });

  const FuncClearSingleAnswer = document.querySelectorAll(".MuiChip-deletable");

  for (let i = 0; i < FuncClearSingleAnswer?.length; i++) {
    FuncClearSingleAnswer[i].addEventListener("click", function () {
      let FilteredQuestion = question.filter(item => item.word !== FuncClearSingleAnswer[i].children[0].innerHTML)
      setQuestions(FilteredQuestion)
    });
  }

  const onChangeHandlerCheck = (i, e) => {
    question.forEach((item, index) => {
      if (i === index) {
        question[i].uppercase = e.target.checked;
      }
    }
    );
  };

  useEffect(() => {
    // let appendSelectedWord = document.querySelectorAll('.MuiAutocomplete-tag')

    // for (let i = 0; i < appendSelectedWord?.length; i++) {
    //   var d = document.createElement('input');
    //   d.type = "checkbox"
    //   d.className = "ml-2 d-none"
    //   d.onchange = (e) => { onChangeHandlerCheck(i, e) }

    //   if (appendSelectedWord[i].classList.contains('hasCheckBox') === false) {
    //     appendSelectedWord[i].insertBefore(d, appendSelectedWord[i].firstChild);
    //     appendSelectedWord[i].classList.add('hasCheckBox')
    //     appendSelectedWord[i].setAttribute('indexOf', i)
    //   }
    // }
    if (user.conditionalType === "WB") {
      dispatch(setWordsMain(question));
    }
    if (user.conditionalType === "L" || user.conditionalType === "T") {
      dispatch(setWordInAnswer(question));
    }
  }, [chosenWord])

  useEffect(async () => {
    if (EditState.edit && EditState.type === "WB") {
      await EditState.edit && EditState.words && EditState.words.map((item, index) => question.push(
        {
          word_id: item.word_id._id,
          word: item.word,
        }
      ))
      await EditState.edit && dispatch(setEditWords(question))
    }
    if (EditState.edit && (EditState.type === "L" || EditState.type === "T")) {
      await EditState.edit && EditState.word && EditState.word.map((item, index) => question.push(
        {
          word_id: item.word_id._id,
          word: item.word,
        }
      ))
      await EditState.edit && dispatch(setEditWord(question))
    }
  }, [EditState.edit])

  const handleFilterWord = (words, language) => {
    setFilterWord(words?.filter((word) => word.language === language));
    setLang(language);
    user.conditionalType !== "T" && user.conditionalType !== "L" && dispatch(setLanguageType(language));
    if (EditState.type !== "T") { EditState.edit && dispatch(setEditLanguage(language)) }
  };
  useEffect(() => {
    if (EditState.edit) {
      setLang(EditState.language);//instead of EditState was user.typeLanguage
      if (EditState.type === "T") {
        handleFilterWord(props?.Words, EditState.language === "fa" ? "en" : "fa");
      }
      else {
        handleFilterWord(props?.Words, EditState.language);//instead of EditState was user.typeLanguage
      }
    } else {
      setLang(user.typeLanguage);//instead of EditState was user.typeLanguage
      if (user.type === "T") {
        handleFilterWord(props?.Words, user.typeLanguage === "fa" ? "en" : "fa");
      }
      else {
        handleFilterWord(props?.Words, "fa");//instead of EditState was user.typeLanguage
      }
    }

    //instead of EditState was user.typeLanguage
  }, [props.Words]);


  useEffect(() => {
    if (EditState.edit && EditState.word?.length === 0) {

      // var documentArr = document.querySelectorAll('.ClearAllinEdit .MuiChip-deletable')
      // console.log(documentArr, "documentArr")
      // documentArr.forEach(el => {
      //   el.parentNode.removeChild(el)
      // })
      setEmptyArr(!props.checkbox)

    }
  }, [EditState.word])
  useEffect(() => {
    if (props.type === "word-bank") {
      dispatch(setWordsMain(question));
      dispatch(setEditWords(question))
    }

    if (props.type === "listening") {
      dispatch(setWordInAnswer(question));
      dispatch(setEditWord(question));
    }
  }, [question])
  console.log(question, "questionquestionquestionquestion")
  return (
    <>
      <div className="container wordbank_taginput">
        <div className="row">
          <div class="d-flex w-100 position-relative">


            <Autocomplete
              onChange={(e, v, o, d) => onChangeHandler(e, v, o, d)}
              className={`rtl wordbank_taginput_${lang} w-100 ${EditState.edit && "ClearAllinEdit"}`}
              multiple
              defaultValue={allanswerFromApi && allanswerFromApi.map((word, index) => word)}
              filterSelectedOptions
              id="tags-standard"
              options={filterWord && filterWord.map((option) => option)}
              getOptionLabel={(option) => option.word}
              getOptionSelected={(option, value) => {
                if (value === "") {
                  return true;
                } else if (value === option.word) {
                  return true;
                }
              }}
              // getOptionDisabled={(options) => (chosenWord.length > 3 ? true : false)}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    index={index}
                    variant="outlined"
                    label={option.word}
                    {...getTagProps({ index })}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  className="placeholder_style"
                  {...params}
                  variant="filled"
                  placeholder={lang === "fa" ? "انتخاب کلمه" : "Chose word"}
                />
              )}
            />

            <div className={`d-flex justify-content-center align-items-center`}>
              <button
                className={`btn ${lang === "fa" ? "text_bold" : ""}`}
                onClick={() => handleFilterWord(props.Words, "fa")}
              >
                Fa
              </button>
              <span>|</span>
              <button
                onClick={() => handleFilterWord(props.Words, "en")}
                className={`btn ${lang === "en" ? "text_bold" : ""}`}
              >
                En
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
